import React, { Component } from 'react';
import './index.css';

// or 'antd/dist/antd.less'

import {
  Form,
  Input,
  DatePicker,
} from 'antd';
import InputPhone from "./input-phone";
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import locale from 'antd/es/date-picker/locale/ru_RU';
import Icofont from 'react-icofont';


function String({ value, onChange }) {
  return (
    <Input allowClear value={value} onChange={(v) => {
      let val = v.target.value
      if (val) {
        val = val.replace(/\s/g, '');
      }
      onChange(val)
    }
    } style={{ width: "100%" }} />
  )
}

function StringEe({ value, onChange }) {
  return (
    <Input allowClear value={value} onChange={(v) => {
      let val = v.target.value
      if (val) {
        val = val.replace(/Ё/g, 'E').replace(/ё/g, 'e');
      }
      onChange(val)
    }
    } style={{ width: "100%" }} />
  )
}

export default function AdminUserUpdate(props) {
  const { object, form } = props;
  React.useEffect(() => {
    form.resetFields();
    if (object) {
      form.setFieldsValue({
        ...object,
        birthday: (object && object.birthday) ? dayjs(object.birthday) : undefined,
      });
    }
  }, [object])

  return (
    <div>
      <Form
        form={form}
        onFinish={props.submit}
        labelAlign={"left"}
        layout={"vertical"}
        initialValues={{
          ...object,
          birthday: (object && object.birthday) ? dayjs(object.birthday) : undefined,
        }}
      >
        <Form.Item label={"Адрес электронной почты"}
          name="email"
          rules={[{ required: true, message: 'Пожалуйста, введите адрес электронной почты!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label={"Фамилия"}
          name="lastname"
          rules={[{ required: true, message: 'Пожалуйста, введите фамилию!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label={"Имя"}
          name="firstname"
          rules={[{ required: true, message: 'Пожалуйста, введите имя!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label={"Отчество"}
          name="patronymic"
        >
          <Input />
        </Form.Item>
        <Form.Item label={"Дата рождения"}
          name="birthday"
          rules={[{ required: true, message: 'Пожалуйста, введите дату рождения!' }]}
        >
          <DatePicker format="DD.MM.YYYY" locale={locale} />
        </Form.Item>
        <Form.Item label={"Телефон"}
          name="phone"
          rules={[
            { required: true, message: 'Пожалуйста, введите телефон!' },
            { pattern: /\d{8,}/g, message: 'Пожалуйста, введите телефон!' }
          ]}
        >
          <InputPhone />
        </Form.Item>
        <Form.Item label={"Псевдоним"}
          name="aliase"
        >
          <Input />
        </Form.Item>
      </Form>
      <div style={{ marginTop: "10px" }}>
        {(object?.tgchatid) && <div style={{ marginTop: "5px", display: "flex", gap: "5px" }}>
          <i className="fa fa-telegram" style={{ fontSize: "22px", color: "#4096ff" }}></i> <span>Аккаунт связан с Telegram</span>
        </div>}
        {(object?.vk) && <div style={{ marginTop: "5px" }}>
          <a target="_blank" href={"https://vk.com/id" + object.vk} style={{ display: "flex", gap: "5px" }}>
            <i className="fa fa-vk" style={{ fontSize: "22px", color: "#4096ff" }}></i>
            <span>Аккаунт связан с VK - id{object.vk}</span>
          </a>
        </div>}
      </div>
    </div>
  );
}

